import React from 'react';
import InfiniteScroll from "react-infinite-scroll-component";

import { ShortlistButton, ShortlistItem } from '../../modules/shortlist';
import { ThemedEventCard, ThemedExtraEventTile } from '../../themes';

const EventCard = ({ event, item }) => {
  const shortlistButton = (
    <ShortlistButton item={ item } isLargeBtn={ false } />
  );
  return (
    <ThemedEventCard event={ event } shortlistButton={ shortlistButton } />
  );
};

const ExtraTile = ({ content, url }) => {
  return <ThemedExtraEventTile content={ content } url={ url } />;
};

const EventsList = ({ events, shortlist, extraTiles, maxEvents, eventCount, nextPage, hasMoreEvents }) => {
  const eventsList = events.map((event) => {
    let item = shortlist.getItem(event.id);
    if (!item) {
      item = new ShortlistItem({ 'event_id': event.id, 'is_shortlisted': false });
      shortlist.items.push(item);
    }
    return <EventCard key={ event.id } event={ event } item={ item } />;
  });

  extraTiles.forEach((tile, index) => {
    eventsList.splice(tile.position, 0, <ExtraTile key={ index } content={ tile.content } url={ tile.url } />);
  });

  if (maxEvents) {
    return eventsList.slice(0, maxEvents);
  }

  return eventsList;
};

export default EventsList;
